import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["source", "pill"];

  declare readonly hasSourceTarget: boolean;
  declare readonly sourceTarget: HTMLSelectElement;
  declare readonly pillTargets: HTMLElement[];

  connect(): void {
    this.sync();
  }

  toggle(event: Event): void {
    const pill = event.currentTarget as HTMLElement;
    const value = pill.dataset.pillValue || "";
    const values = this.selectedValues;

    values.has(value) ? values.delete(value) : values.add(value);
    this.apply(values);
  }

  selectAll(): void {
    this.apply(new Set(this.options.map((option) => option.value)));
  }

  deselectAll(): void {
    this.apply(new Set());
  }

  // auto-save reverts the select in place without firing `change` when a save
  // fails, so re-read it once that controller reports back.
  sync(): void {
    const selected = this.selectedValues;

    this.pillTargets.forEach((pill) => {
      const on = selected.has(pill.dataset.pillValue || "");
      pill.classList.toggle("selected", on);
      pill.setAttribute("aria-pressed", String(on));
    });
  }

  private apply(values: Set<string>): void {
    if (!this.hasSourceTarget) return;

    this.options.forEach((option) => {
      option.selected = values.has(option.value);
    });
    this.sync();
    this.sourceTarget.dispatchEvent(new Event("change", { bubbles: true }));
  }

  private get options(): HTMLOptionElement[] {
    return this.hasSourceTarget ? Array.from(this.sourceTarget.options) : [];
  }

  private get selectedValues(): Set<string> {
    return new Set(this.options.filter((option) => option.selected).map((option) => option.value));
  }
}
